import * as types from '@models/types';

// @ts-ignore
export const rotateToCountry = (
  instance: any,
  polygonSeries: any,
  polygonSeriesHeatMap: any,
  country: types.CountryType,
) => {
  const { latitude, longitude, countryCode } = country;

  instance.animate({
    key: 'rotationX',
    to: -longitude,
  });

  instance.animate({
    key: 'rotationY',
    to: -latitude,
  });

  const countryDataItem = polygonSeries.getDataItemById(countryCode);

  if (countryDataItem) {
    const countryPolygon = countryDataItem.get('mapPolygon');
    countryPolygon.set('active', true);
  }

  if (polygonSeriesHeatMap !== null) {
    const countryDataItemHeatMap =
      polygonSeriesHeatMap.getDataItemById(countryCode);

    if (countryDataItemHeatMap) {
      const countryPolygonHeatMap = countryDataItemHeatMap.get('mapPolygon');
      countryPolygonHeatMap.set('active', true);
    }
  }
};
